import './InputDualNumber.scss';

import { InputErrorMessage } from '@whistler-ui/k2/components/InputErrorMessage';
import PropTypes from 'prop-types';
import React from 'react';

const InputDualNumber = ({
  name,
  inputs = [],
  value,
  error,
  errorMessage,
  onChange = () => null,
}) => {
  const componentName = 'c-InputDualNumber';

  return (
    <div className={componentName}>
      <div className={`${componentName}__input_group`}>
        {inputs.map(
          (
            { name, label, inputComponent: InputComponent, inputProps },
            index,
          ) => (
            <div
              key={`${componentName}__field-${index}`}
              className={`${componentName}_group`}
            >
              {label}
              <div className={`${componentName}__field`}>
                <InputComponent
                  {...inputProps}
                  name={name}
                  error={error}
                  autoComplete={'off'}
                  value={value[name]}
                  onChange={onChange}
                />
              </div>
            </div>
          ),
        )}
      </div>
      <InputErrorMessage
        id={`${name}__ErrorMessage`}
        error={error}
        errorMessage={errorMessage}
      />
    </div>
  );
};

InputDualNumber.propTypes = {
  inputs: PropTypes.array,
};

export default InputDualNumber;
